/**
 * tree_service_tampa.jsx
 *
 * Tampa location page — demonstrates how a second city is just a different config.
 * No new CSS or component code needed.
 */

import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Tampa-specific images ────────────────────────────────────────────────────
import heroImg   from '../images/tampa3.webp';  // swap for your Tampa shot
import bgImg     from '../images/image8.webp';        // can share the same BG
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const tampaConfig = {
  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Tampa Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree removal and trimming in Tampa, FL. Sam\'s Tree Service handles the tough jobs safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_tampa',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Tampa',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Tampa Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we take on the difficult and dangerous 
     jobs that many companies won't touch. If you're dealing with overgrown, unstable, 
     or hazardous trees in <strong>Tampa</strong>, our trained team has the skill and equipment to 
     remove risks and protect your property. Whether branches are hanging over your 
     roof, crowding your driveway, threatening your carport, or growing too close to 
     power lines, we deliver precise trimming and targeted removal that restores safety 
     and promotes healthy tree growth.`,

    `We specialize in <strong>dangerous tree</strong> situations—including storm-damaged 
     limbs, leaning or weakened trunks, rotted sections, and heavy overgrowth that 
     puts your home or business at risk. From detailed branch reductions to full 
     canopy clearance, every service is customized to the unique needs of your landscape 
     and Florida's storm-prone environment.`,

    `<strong>Sam's Tree Service</strong> provides dependable, affordable, and expert 
     tree care throughout <strong>Tampa</strong> and the surrounding <strong>Tampa Bay area</strong>, 
     ensuring your property stays safe and your trees remain healthy year-round.`,
  ],

  ctaLabel: 'Get a Free Estimate',

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Tampa, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Tampa = () => <LocationPage config={tampaConfig} />;

export default Services_Tampa;
